import CityLandingPage from './page';

const barueriData = {
  cityName: 'Barueri',
  state: 'SP',
  slug: 'palestra-silenciosa-barueri',
  coordinates: { lat: -23.5112, lng: -46.8764 },
  phone: '(11) 91777-6227',
  localKeywords: [
    'palestra silenciosa barueri',
    'silent conference alphaville',
    'aluguel fones sem fio barueri',
    'eventos corporativos alphaville',
    'tradução simultânea barueri',
    'festa silenciosa alphaville',
  ],
  heroTitle: 'palestra silenciosa barueri e alphaville',
  heroSubtitle: 'Tecnologia de áudio sem fio premium para eventos corporativos em Barueri e Alphaville. O maior centro empresarial da América Latina com suporte técnico de alto nível para multinacionais.',
  localStats: { clients: '120+', satisfaction: '99%' },
  localTestimonials: [],
  localFAQs: [
    { question: 'Vocês atendem todo o complexo Alphaville e arredores?', answer: 'Sim! Atendemos Alphaville (centro industrial e empresarial), Tamboré, Santana de Parnaíba e toda a região de Barueri. Estamos a minutos dos principais centros empresariais.' },
    { question: 'Qual o prazo para eventos corporativos em Barueri/Alphaville?', answer: 'Recomendamos 1 a 2 semanas para eventos padrão. Para grandes convenções e kick-offs corporativos em Alphaville, sugerimos 3 semanas. Temos agenda flexível para atender demandas urgentes de empresas.' },
    { question: 'Vocês têm experiência com eventos de multinacionais em Alphaville?', answer: 'Sim, atendemos regularmente dezenas de multinacionais com sede em Alphaville e Barueri. Conhecemos os protocolos de segurança, requisitos de compliance e padrões de qualidade exigidos por grandes corporações.' },
    { question: 'Quantos fones estão disponíveis para Alphaville e Barueri?', answer: 'Nosso estoque na região é robusto: de pequenas reuniões (20 fones) a grandes convenções corporativas (500+ fones). Equipamentos premium com áudio cristalino e bateria para 12h de uso contínuo.' },
    { question: 'Vocês fazem tradução simultânea para eventos multilíngues em Alphaville?', answer: 'Sim! Essa é uma das nossas especialidades. Atendemos eventos com até 10 idiomas simultâneos em Alphaville, com intérpretes profissionais e equipamentos de tradução integrados ao sistema de palestra silenciosa.' },
  ],
  seoTitle: 'Barueri e Alphaville Palestra Silenciosa | Aluguel Fones SP | STIB',
  seoDescription: 'Palestra silenciosa Barueri e Alphaville: aluguel de fones sem fio para eventos corporativos no maior polo empresarial da América Latina. Multinacionais atendidas. Solicite orçamento!',
  relatedCities: [
    { name: 'São Paulo (Capital)', slug: '/sao-paulo', region: 'Capital' },
    { name: 'Campinas', slug: '/campinas', region: 'Região Metropolitana' },
    { name: 'São José dos Campos', slug: '/sao-jose-dos-campos', region: 'Vale do Paraíba' },
    { name: 'Ribeirão Preto', slug: '/ribeirao-preto', region: 'Interior Norte' },
    { name: 'Santos', slug: '/santos', region: 'Baixada Santista' },
    { name: 'Guarulhos', slug: '/guarulhos', region: 'Grande SP Leste' },
    { name: 'São Bernardo do Campo', slug: '/sao-bernardo-do-campo', region: 'ABCD Paulista' },
    { name: 'Jundiaí', slug: '/jundiai', region: 'Interior Oeste' },
  ],
};

export default function BarueriLandingPage() {
  return <CityLandingPage cityData={barueriData} />;
}